module.exports = __webpack_public_path__ + "img/icon-close.c54595ba.svg";